import { FC, ReactNode } from 'react';

import { ButtonColorTypes, ButtonProps, ButtonSizes } from '~src/shared/buttons/basicButtons/BaseButton.sc';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import { PartialBy } from '~src/types';

import LoadingInner, { LoaderWrapper } from './LoadingInner';

interface Props extends PartialBy<ButtonProps, '$buttonSize'|'$buttonColor'> {
  isLoading: boolean;
  onClick?(): void;
  children: ReactNode;
}

const loaderColorMatch = {
  [ButtonColorTypes.Blue]: undefined,
  [ButtonColorTypes.Reddish]: 'pink' as const,
  [ButtonColorTypes.White]: 'white' as const,
  [ButtonColorTypes.LightBlue]: 'pink' as const,
  [ButtonColorTypes.Green]: 'pink' as const,
};

const SecondaryButtonLoading: FC<Props> = (props) => {
  const { isLoading, $buttonColor = ButtonColorTypes.Blue, $buttonSize = ButtonSizes.Medium, ...restProps } = props;
  return (
    <LoaderWrapper className={isLoading ? 'loading' : ''}>
      <SecondaryButton {...restProps} $buttonColor={$buttonColor} $buttonSize={$buttonSize}>
        <LoadingInner loaderColor={$buttonColor && loaderColorMatch[$buttonColor]} isLoading={isLoading}>
          {props.children}
        </LoadingInner>
      </SecondaryButton>
    </LoaderWrapper>
  );
};

export default SecondaryButtonLoading;
